import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpDataFileImportService } from '../../../../service/http-data-file-import.service';
import { DataFileImportDto, DecryptionKeyDto } from '../../../../service/dto';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
	selector: 'app-import-view-encryption-key',
	standalone: false,
	templateUrl: './import-view-encryption-key.component.html',
	styleUrl: './import-view-encryption-key.component.scss'
})
export class ImportViewEncryptionKeyComponent {
	@Input() private data!: DataFileImportDto;
	agentPassword = '';
	decryptionKey?: DecryptionKeyDto;
	copied=false;
	faCopy=faCopy;

	constructor(public activeModal: NgbActiveModal, private service: HttpDataFileImportService, private messageService: NzMessageService) { }

	onSubmit() {
		if (this.agentPassword.trim()) {
			this.copied=false;
			this.service.getDecryptionKey(this.data.id, this.agentPassword).subscribe(result => {
				this.decryptionKey = result;
			});
		}
	}

	onCancel() {
		this.activeModal.dismiss('cancel');
	}

	copyToClipboard(value: string) {
		navigator.clipboard.writeText(value).then(() => {
			this.copied=true;
			this.messageService.info('Copied!');
		}).catch(err => {
			this.messageService.error('Failed to copy.');
		});
	}
}
